import React, {useEffect} from 'react';
import $ from "jquery";

function NewEmployeeModalTable(props) {

    useEffect(() => {
        //initialize datatable
        $('#newEmployeeTable').DataTable({
            dom: 'frtilp', language: {
                fontcolor: 'white', url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
            }, oLanguage: {
                sSearch: '', searchPlaceholder: 'Suchen'
            }, "paging": true, "pageLength": 5
        });
    }, []);

    // function getStundeMinuten(stunden) {
    //     let stunde = Math.floor(stunden);
    //     let minute = Math.round((stunden - stunde) * 60);
    //
    //     if (minute === 60) {
    //         stunde++;
    //         minute = 0;
    //     }
    //
    //     let output = stunde + " Stunde";
    //     if (stunde !== 1) {
    //         output += "n";
    //     }
    //
    //     if (minute > 0) {
    //         output += " " + minute + " Minute";
    //         if (minute !== 1) {
    //             output += "n";
    //         }
    //     }
    //
    //     return output;
    // }

    function addEmployee(id, firstName, lastName, role) {
        props.setIsChange(false)
        if (props.employeeDataInfo.find(item => ((item.firstName===firstName) &&
            (item.lastName===lastName))) === undefined) {
            let newEmployee = {
                "id": id,
                "firstName": firstName,
                "lastName": lastName,
                "role": role,
                "zone": "",
                "workHours": {
                    "startDate": "",
                    "endDate": "",
                    "startTime": props.firstCoworkerStartTime,
                    "endTime": props.firstCoworkerEndTime,
                    "duration":""
                }
            }
            props.setEmployeeDataInfo([...props.employeeDataInfo, newEmployee])
            props.employeeDataInfo.push(newEmployee)
        } else {
            alert("Es ist schon da!")
        }
    }

    function getNewEmployeeTableBody(users) {
        let result = users.filter(md =>
             props.employeeDataInfo.every(fd => (fd.lastName !== md.lastname && fd.firstName !== md.firstname)))
        //return users.map((item) => (<tr key={item.id}
        return result.map((item) => (<tr key={item.id}
                                        onClick={() => addEmployee(item.id, item.firstname, item.lastname, item.role)}>
            <td>{item.firstname}</td>
            <td>{item.lastname}</td>
        </tr>));
    }

    return (
        <div>
            <table id="newEmployeeTable" className="table handwai-white-text">
                <thead>
                <tr>
                    <th>Vorname</th>
                    <th>Nachname</th>
                </tr>
                </thead>
                <tbody>{getNewEmployeeTableBody(props.users)}</tbody>
            </table>
        </div>
    );
}

export default NewEmployeeModalTable;
